import type { Response as NodeFetchResponse } from 'node-fetch';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import { FetchClient as FetchClientBase } from './FetchClient';
import { FetchClientDomain } from './domain';

export class FetchClient extends FetchClientBase {
    readonly #datadogClient = DatadogRUMService.Client.getInstance();
    static #instance: FetchClient;

    private constructor() {
        super();
    }

    static getInstance(): FetchClient {
        if (!FetchClient.#instance) {
            FetchClient.#instance = new FetchClient();
        }
        return FetchClient.#instance;
    }
    protected override async performFetch<TResponse extends Response | NodeFetchResponse = Response>(
        url: RequestInfo | URL,
        opts: RequestInit
    ): Promise<TResponse> {
        try {
            return (await globalThis.fetch(url, opts)) as TResponse;
        } catch (err) {
            const thrownError = err as Error;
            const optsWithTimeout = opts as FetchClientDomain.TimeoutableClientFetchConfig;
            if (thrownError.message === 'Load failed') {
                const error = new FetchClient.FetchRequestBlockedError(thrownError.message);
                await this.#datadogClient.addError(error, {
                    url,
                    opts: optsWithTimeout,
                    timeout: optsWithTimeout.timeout,
                });
                throw error;
            }
            if (thrownError.name === 'AbortError') {
                const error = new FetchClient.AbortError(`Fetch request timeout: ${url}`);
                await this.#datadogClient.addError(error, {
                    url,
                    opts: optsWithTimeout,
                    timeout: optsWithTimeout.timeout,
                });
                throw error;
            }
            throw err;
        }
    }
}
